import AssetOverlayLabel from './AssetOverlayLabel';

export default AssetOverlayLabel;
